/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");
    document.querySelector("html").classList.add("noScroll");


    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }


    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelectorAll('.m-cart-count').forEach(element => element.textContent = cart.item_count);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // update count text
    document.querySelector("#miniCartHeaderTitleCount").textContent = "(" + cart.item_count + ")";
    document.querySelector("#miniCartFooterInfoTitleCount").textContent = " (" + cart.item_count + " items)";


    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // update subtotal
    document.querySelector("#miniCartFooterInfoPriceTotal").textContent = price(cart.total_price);

    // check for compare price
    document.querySelector("#miniCartFooterInfoPriceCompare").textContent = "";
    if (cart.original_total_price > cart.total_price) {
        document.querySelector("#miniCartFooterInfoPriceCompare").textContent = price(cart.original_total_price);
    }


    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {
            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-id="${item.variant_id}" 
                     data-plan="${sellingPlanID}"
                >
                    ${sellingPlanName}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">  
                <img class="miniCartBodyItemImage" src="${item.image}&width=200"  alt="${item.variant_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34375 3.28125H12.6562H2.34375Z" fill="#8F8F8F"></path><path d="M2.34375 3.28125H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
                <!-- ${upgradeHTML()}-->
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const variantID = parseInt(this.dataset.id);
            const sellingPlanID = parseInt(this.dataset.plan);

            // add loading animation
            this.classList.add("loading");

            // remove this product from the cart
            await changeProduct({
                id: key,
                quantity: 0,
            });

            // add new product to cart (note, we don't change since we have a custom atc function)
            await addProduct({
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            });

            await openCart();

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // reset upsell selects (hide all)
    document.querySelectorAll(".miniCartUpsellItemSelect")?.forEach(element => {
        element.classList.add("active");
    });

    document.querySelectorAll(".miniCartUpsellItemWrapVariants")?.forEach(element => {
        element.classList.remove("active");
        element.textContent = "OPTIONS";
    });

    // ~~~~free gifts~~~~

    // hide banner by default
    document.querySelector("#miniCartHeaderBanner").classList.remove("active");

    // check if there are no possible gifts
    if (giftBlocks.length === 0) {
        // hide banner
        document.querySelector("#miniCartHeaderBanner").classList.add("active");

        // hide shipping bar
        document.querySelector("#miniCartHeaderBar").classList.add("active");
        return;
    }

    // loop over gift tiers
    giftBlocks.forEach(gift => {
        // get gift elements
        const giftHeaderItem = document.querySelector(`.miniCartHeaderGiftsItem[data-id="${gift.id}"]`);
        const giftFreebieItem = document.querySelector(`.miniCartHeaderFreebiesBodyItem[data-id="${gift.id}"]`);

        // check if gift threshold has been reached
        if (cart.items_subtotal_price > gift.settings.threshold * 100) {
            giftHeaderItem?.classList.add("active");
            // don't show freebies that have already been added to the cart
            const isGiftInCart = cart.items.find(item => item.handle === gift.settings.product);
            if (isGiftInCart) {
                giftFreebieItem?.classList.remove("active");
            } else {
                giftFreebieItem?.classList.add("active");
            }
        } else {
            giftHeaderItem?.classList.remove("active");
            giftFreebieItem?.classList.remove("active");
        }
    });

    // get the next tier threshold
    const nextGift = giftBlocks.find(gift => cart.items_subtotal_price < (gift.settings.threshold * 100));

    // if there's a next gift, update text, if not show congrats message
    if (nextGift) {
        document.querySelector("#miniCartHeaderBanner").innerHTML = `Spend $${((nextGift.settings.threshold * 100 - cart.items_subtotal_price) / 100).toFixed(2)} more to unlock <b>${nextGift.settings.text}</b>`;
    } else {
        document.querySelector("#miniCartHeaderBanner").innerHTML = `🎉Congrats! You've unlocked <b>Everything!</b>`;
    }

    // update gift bar width
    const maxThreshold = giftBlocks[giftBlocks.length - 1].settings.threshold * 100;
    document.querySelector("#miniCartHeaderBarInner").style.width = (cart.items_subtotal_price / maxThreshold) * 100 + "%";

    // reset gift items
    document.querySelectorAll('.miniCartHeaderFreebiesBodyItem')?.forEach(function (element) {
        // reset select dropdown
        element.querySelector('.miniCartHeaderFreebiesBodySelect').classList.add("active");
        element.querySelector('.miniCartHeaderFreebiesBodyItemWrapVariants').textContent = "OPTIONS";
        element.querySelector('.miniCartHeaderFreebiesBodyItemWrapVariants').classList.remove("active");
    });

}

//  GIFTS
// listen for select change for gift variants
document.querySelectorAll('.miniCartHeaderFreebiesBodySelect')?.forEach(function (element) {
    element.addEventListener("change", function () {
        // update button variantID
        this.closest('.miniCartHeaderFreebiesBodyItem').querySelector('.miniCartHeaderFreebiesBodyItemWrapVariants').dataset.variant = this.value;

        // update image source
        this.closest('.miniCartHeaderFreebiesBodyItem').querySelector('.miniCartHeaderFreebiesBodyItemWrapImg').src = this.selectedOptions[0].dataset.image;

        // add to cart
        this.closest('.miniCartHeaderFreebiesBodyItem').querySelector('.miniCartHeaderFreebiesBodyItemWrapVariants').click();
    });
})


// add variant gift to cart if active
// if not active show select dropdown
document.querySelectorAll('.miniCartHeaderFreebiesBodyItemWrapVariants')?.forEach(function (element) {
    element.addEventListener("click", async function () {

        // if active, atc and return
        if (this.classList.contains("active")) {

            // return if no variant selected
            if (this.dataset.variant === "ProductVariantDrop") {
                return;
            }

            // add loading animation
            this.classList.add("loading");

            // create form data
            let formData = {
                items: [{
                    quantity: 1,
                    id: this.dataset.variant,
                }]
            };

            // add product upsell
            await addProduct(formData);

            // remove loading animation
            this.classList.remove("loading");

            await openCart();

            return;
        }

        // not active, show select dropdown

        // show select dropdown
        this.closest('.miniCartHeaderFreebiesBodyItem').querySelector('.miniCartHeaderFreebiesBodySelect').classList.remove("active");

        // update button text to Add
        this.closest('.miniCartHeaderFreebiesBodyItem').querySelector('.miniCartHeaderFreebiesBodyItemWrapVariants').textContent = "ADD";

        // add active to button class to allow ATC functionality
        this.classList.add("active");
    });
});


// Add Default Gift function
document.querySelectorAll('.miniCartHeaderFreebiesBodyItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartHeaderFreebiesBodyItem').dataset.variant;

        // add loading animation
        this.classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartHeaderFreebiesBodyItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartHeaderFreebiesBodyItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// UPSELLS

// listen for select change for upsell variants
document.querySelectorAll('.miniCartUpsellItemSelect')?.forEach(function (element) {
    element.addEventListener("change", function () {
        // update button variantID
        this.closest('.miniCartUpsellItem').querySelector('.miniCartUpsellItemWrapVariants').dataset.variant = this.value;

        // add to cart
        this.closest('.miniCartUpsellItem').querySelector('.miniCartUpsellItemWrapVariants').click();

    });
})

// add variant upsell to cart if active
// if not active show select dropdown
document.querySelectorAll('.miniCartUpsellItemWrapVariants')?.forEach(function (element) {
    element.addEventListener("click", async function () {

        // if active, atc and return
        if (this.classList.contains("active")) {

            // return if no variant selected
            if (this.dataset.variant === "ProductVariantDrop") {
                return;
            }

            // add loading animation
            this.classList.add("loading");

            // create form data
            let formData = {
                items: [{
                    quantity: 1,
                    id: this.dataset.variant,
                }]
            };

            // add product upsell
            await addProduct(formData);

            // remove loading animation
            this.classList.remove("loading");

            await openCart();

            return;
        }

        // not active, show select dropdown

        // show select dropdown
        this.closest('.miniCartUpsellItem').querySelector('.miniCartUpsellItemSelect').classList.remove("active");

        // update button text to Add
        this.closest('.miniCartUpsellItem').querySelector('.miniCartUpsellItemWrapVariants').textContent = "ADD";

        // add active to button class to allow ATC functionality
        this.classList.add("active");
    });
});


// Add Default Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // add loading animation
        this.classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector("html").classList.remove("noScroll");

}

// open cart event listener
document.querySelectorAll(`[href="/cart"]`).forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = "/checkout";
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));